/**
 * generatePayload — reads current engine state, produces all outputs.
 *
 * v0.42 rewrite — sources registry
 *
 * Loaded AFTER app.js. Attaches to window.StickerEngine.
 *
 * Outputs:
 *   colorPreviewSvg  — full-color SVG as customer saw it
 *   productionSvg    — monochrome SVG for thermal transfer
 *   sourceFile       — customer's uploaded image data URI (or null)
 *   recipe           — JSON string of customer state for re-rendering
 *
 * All SVG rendering delegates to the existing engine's svgBuilder.js.
 */

(function () {
	'use strict';

	var eng = window.StickerEngine = window.StickerEngine || {};

	/**
	 * Generate all output payloads from the current engine state.
	 * @returns {{ colorPreviewSvg: string, productionSvg: string, sourceFile: string|null, recipe: string }}
	 */
	eng.generatePayload = function () {
		var state = eng._getState();
		if (!state) throw new Error('StickerEngine: state not initialized');

		// ── Deep clone to avoid mutating live state ────────────
		var clone = JSON.parse(JSON.stringify(state));

		// ── 1. Color preview SVG ────────────────────────────────
		clone.style.showTracks = false;
		var colorComputed = window.StickerEngine.computeLayout(clone);
		var colorSvgEl = window.StickerEngine.buildStickerSVG(clone, colorComputed);
		var colorPreviewSvg = new XMLSerializer().serializeToString(colorSvgEl);

		// ── 2. Monochrome production SVG ────────────────────────
		var prodState = JSON.parse(JSON.stringify(state));
		prodState.style.showTracks = false;
		prodState.style.ribbonColor = 'black';
		prodState.style.paperColor = 'none';          // transparent background
		prodState.interactive = { foilShift: 0 };     // no interactive foil offset

		var prodComputed = window.StickerEngine.computeLayout(prodState);
		var prodSvgEl = window.StickerEngine.buildStickerSVG(prodState, prodComputed);
		var productionSvg = new XMLSerializer().serializeToString(prodSvgEl);

		// ── 3. Customer source file ────────────────────────────
		var sourceFile = (state.activeSourceId === 'upload')
			? (state.sources.upload.imageDataUrl || null)
			: (state.sources.design.graphic && state.sources.design.graphic.graphicId || null);

		// ── 4. Recipe JSON ─────────────────────────────────────
		// v0.42 fields: sources registry, designText1/2/3, uploadScale/Threshold/FitMode
		var recipe = {
			recipeVersion:  '0.42',
			configRef:     (window.StickerConfig && window.StickerConfig.productHandle) || 'unknown',
			activeSourceId: state.activeSourceId,

			// Design source
			designText1:   state.sources.design.text1 ? pick(state.sources.design.text1, ['visible','enabled','text','fontFamily','fontWeight','fontSize','letterSpacing','lineSpacing','textAlign','offsetY','isEditable','label']) : null,
			designText2:   state.sources.design.text2 ? pick(state.sources.design.text2, ['visible','enabled','text','fontFamily','fontWeight','fontSize','letterSpacing','lineSpacing','textAlign','offsetY','isEditable','label']) : null,
			designText3:   state.sources.design.text3 ? pick(state.sources.design.text3, ['visible','enabled','text','fontFamily','fontWeight','fontSize','letterSpacing','lineSpacing','textAlign','offsetY','isEditable','label']) : null,
			designGraphic: state.sources.design.graphic ? pick(state.sources.design.graphic, ['visible','enabled','graphicId','scale','offsetY','rotation']) : null,
			designThreshold: state.sources.design.centerThreshold,

			// Upload source
			uploadScale:     state.sources.upload.scale,
			uploadThreshold: state.sources.upload.threshold,
			uploadFitMode:   state.sources.upload.fitMode,

			// Shared (unchanged)
			outerRing:     pick(state.outerRing, ['enabled','topText','bottomText','topFontSize','bottomFontSize','fontWeight','fontFamily','letterSpacing','ringScale','trackRadius','rotation','offsetY']),
			innerRing:     pick(state.innerRing, ['enabled','topText','bottomText','topFontSize','bottomFontSize','fontWeight','fontFamily','letterSpacing','ringScale','trackRadius','rotation','offsetY']),
			decoration:    pick(state.decoration, ['baseSize','graphic','show']),
			style:         pick(state.style, ['paperColor','ribbonColor','printSafeBuffer']),
		};

		return {
			colorPreviewSvg: colorPreviewSvg,
			productionSvg:   productionSvg,
			sourceFile:      sourceFile,
			recipe:          JSON.stringify(recipe),
		};
	};

	// ── Helper: pick subset of object keys ───────────────────
	function pick(obj, keys) {
		var out = {};
		keys.forEach(function (k) { out[k] = obj[k]; });
		return out;
	}

})();
